// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"33227801","900":"e038e1a5"}[chunkId] + ".chunk.js";
};